export default __webpack_public_path__ + "static/media/lupa.67093972.svg";